import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-close-round';
export var ID = 'icon-close-round';
/* eslint-disable max-len */

export var SVGCloseRound = function SVGCloseRound() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 22 22"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-778.000000, -388.000000)",
    fill: "#BAB7B7"
  }, React.createElement("path", {
    d: "M790.44375,399.155 L794.31,395.28875 L793.02125,394 L789.155,397.86625 L785.28875,394 L784,395.28875 L787.86625,399.155 L784,403.02125 L785.28875,404.31 L789.155,400.44375 L793.02125,404.31 L794.31,403.02125 L790.44375,399.155 Z M789,410 C795.075132,410 800,405.075132 800,399 C800,392.924868 795.075132,388 789,388 C782.924868,388 778,392.924868 778,399 C778,405.075132 782.924868,410 789,410 Z"
  }))));
};
/* eslint-disable max-len */

var CloseRound = function CloseRound(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGCloseRound
  });
};

CloseRound.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default CloseRound;